/*!
 * Wandelt eine Kapitelnummer in einen String um welcher ordnenbar ist.
 *
 * @param chapter_name String im Muster \d+(\.\d+)*
 * @return String mit führenden 0 zwischen den Punkten
 */
export const chapter_normalize = chapter_name =>
  chapter_name
    .split(".")
    .map(val => val.padStart(6, "0"))
    .join(".");

export const chapter_cmp = (lhs, rhs) => {
  const norm_lhs = chapter_normalize(lhs);
  const norm_rhs = chapter_normalize(rhs);
  if (norm_lhs < norm_rhs) return -1;
  if (norm_lhs > norm_rhs) return 1;
  return 0;
};

export const array_item_cmp = (lhs, rhs) => {
  lhs;
  rhs;
  return 0;
};
